import { useState, useEffect } from "react"

export function useDebounce<T>(value: T, delay: number = 500): T {
	const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

    return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);

  return debouncedValue
}
type F = (...args: any) => void

export function useDebounceCallback(fn: F, t: number = 500): F {
  let timer: NodeJS.Timeout
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => fn(...args), t)
  }
}
